import React from 'react';
import './Home.css';
import p1 from './p1.jpg';
import { useNavigate } from 'react-router-dom';
import FreeSiteBanner from '../components/FreeSiteBanner';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">

      <FreeSiteBanner />

      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-text">
          <span className="hero-eyebrow">Web &amp; App Development</span>
          <h1>Your Website Should Be Your <em>Best Salesman</em></h1>
          <p>
            We build high-converting websites and apps for small businesses across Ontario.
            5 years. 120+ successful projects. Real results you can measure.
          </p>
          <div className="hero-ctas">
            <button className="btn-primary" onClick={() => navigate('/projects')}>
              See Our Work
            </button>
            <button className="btn-secondary" onClick={() => navigate('/contact')}>
              Get in Touch
            </button>
          </div>
        </div>
        <div className="hero-image">
          <img src={p1} alt="Grow Your Online Presence" />
        </div>
      </section>

      {/* ── STATS BAR ── */}
      <div className="stats-bar">
        <div className="stat-item">
          <div className="stat-num">120<span>+</span></div>
          <div className="stat-label">Successful Projects</div>
        </div>
        <div className="stat-item">
          <div className="stat-num">30<span>k</span></div>
          <div className="stat-label">Organic App Downloads</div>
        </div>
        <div className="stat-item">
          <div className="stat-num">5<span>yr</span></div>
          <div className="stat-label">In Business</div>
        </div>
        <div className="stat-item">
          <div className="stat-num">100<span>%</span></div>
          <div className="stat-label">Ontario-Based</div>
        </div>
      </div>

      {/* ── SERVICES ── */}
      <section className="services">
        <div className="section-eyebrow">What We Do</div>
        <div className="section-title">Built to Convert. Designed to Impress.</div>
        <p className="section-sub">
          From stunning landing pages to full-scale apps, we craft digital products that work as
          hard as you do.
        </p>
        <div className="services-grid">
          <div className="service-box">
            <div className="service-icon">🌐</div>
            <h2>Web Development</h2>
            <p>
              Modern, responsive websites that attract customers and drive real results. We've
              helped 120+ small businesses across Ontario dominate their local market online.
            </p>
          </div>
          <div className="service-box">
            <div className="service-icon">📱</div>
            <h2>App Development</h2>
            <p>
              Our biggest app hit 30,000 organic downloads no paid ads. Ask us what we can do for your industry.
            </p>
          </div>
          <div className="service-box">
            <div className="service-icon">🔍</div>
            <h2>Web Consulting</h2>
            <p>
              Not sure where your site is losing customers? We audit, advise, and give you a
              clear action plan. First call is always free.
            </p>
          </div>
        </div>
      </section>

      {/* ── CONSULT BANNER ── */}
      <div className="consult-banner">
        <div className="consult-inner">
          <div className="consult-text">
            <div className="consult-tag">Free 15-Minute Call</div>
            <h2>Is Your Website Leaking Sales?</h2>
            <p>
              Most small business websites quietly lose customers every single day from slow load
              times, confusing layouts, no clear call to action.{' '}
              <strong>We'll spot the leaks in 15 minutes, for free. </strong> 
              Honest, actionable advice from someone who's fixed this 120+ times.
            </p>
          </div>
          <button
            className="btn-bright"
            onClick={() => window.open('https://calendly.com/mattduarte56/15min')}
          >
            Book My Free Call →
          </button>
        </div>
      </div>

      {/* ── CLIENT LOGOS ── */}
      <section className="clients">
        <div className="section-eyebrow">Trusted By</div>
        <div className="section-title">We've Worked With Great Companies</div>
        <p className="section-sub">
          From local startups to established Ontario businesses.
        </p>
        <div className="logos-row">
          {[
            { icon: '🏗️', name: 'Lloyd Livestock' },
            { icon: '🛒', name: 'HR Proactive' },
            { icon: '🏥', name: 'Speed Hockey' },
            { icon: '🍕', name: 'Bulletproof Interviewing' },
            { icon: '🏠', name: 'Classic Fences and Decks' },
            { icon: '⚙️', name: 'Mental Game Academy' },
                { icon: '⚙️', name: 'Trusted by over 100+' },
          ].map((c, i) => (
            <div className="logo-pill" key={i}>
           
              <span className="logo-name">{c.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── REVIEWS ── */}
      <section className="reviews">
        <div className="section-eyebrow">Client Reviews</div>
        <div className="section-title">Don't Take Our Word for It</div>
        <p className="section-sub">
          Real feedback from real Ontario business owners. Add your actual Google reviews here.
        </p>
        <div className="reviews-grid">
          <div className="review-card">
            <div className="review-stars">★★★★★</div>
            <p className="review-text">
              "DuDigital completely transformed our online presence. Within weeks of launching our
              new site, we saw a noticeable increase in leads. Best investment we made this year."
            </p>
            <div className="review-author">
              <div className="review-avatar">👤</div>
              <div>
                <div className="review-name">Aaron C.</div>
                <div className="review-role">Owner, Classic Fences and Decks</div>
              </div>
            </div>
          </div>
          <div className="review-card">
            <div className="review-stars">★★★★★</div>
            <p className="review-text">
              "Professional, fast, and they actually listened to what we needed. The free
              consultation alone gave us more clarity than months of trying to figure it out
              ourselves."
            </p>
            <div className="review-author">
              <div className="review-avatar">👤</div>
              <div>
                <div className="review-name">James T.</div>
                <div className="review-role">Founder, Home Services Co. - Hamilton</div>
              </div>
            </div>
          </div>
          <div className="review-card">
            <div className="review-stars">★★★★★</div>
            <p className="review-text">
              "We applied for the free website program and couldn't believe the quality. They
              treated us like a paying client from day one. Our bookings have doubled."
            </p>
            <div className="review-author">
              <div className="review-avatar">👤</div>
              <div>
                <div className="review-name">Priya K.</div>
                <div className="review-role">Co-founder, Wellness Studio - St. Catharines</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── PRICING ── */}
      <section className="pricing">
        <div className="section-eyebrow">Transparent Pricing</div>
        <div className="section-title">Your Website Is Your Best Investment</div>
        <p className="section-sub">
          A great website pays for itself, often within the first month. 
        </p>
        <div className="pricing-grid">
          <div className="pricing-card">
            <h3>Static Site</h3>
            <div className="pricing-price">$100<span> per page</span></div>
            <p className="pricing-desc">Get online fast with a clean, professional presence that actually converts.</p>
            <ul className="pricing-features">
         
              <li>Mobile responsive</li>
              <li>Contact form</li>
              <li>Basic SEO setup</li>
              <li>2 revision rounds</li>
            </ul>
            <button className="btn-outline-dark" onClick={() => navigate('/contact')}>Get Started</button>
          </div>

          <div className="pricing-card featured">
            <div className="pricing-badge">Most Popular</div>
            <h3>Business Site</h3>
            <div className="pricing-price">$1,499<span> one-time</span></div>
            <p className="pricing-desc">A full conversion-focused site built to grow with your business.</p>
            <ul className="pricing-features">
              <li>Up to 10 pages</li>
              <li>Custom design</li>
              <li>Booking or e-commerce</li>
              <li>Full SEO optimization</li>
              <li>Unlimited revisions</li>
            </ul>
            <button className="btn-outline-white" onClick={() => navigate('/contact')}>Get Started</button>
          </div>

          <div className="pricing-card">
            <h3>Custom / App</h3>
            <div className="pricing-price">Custom<span> quote</span></div>
            <p className="pricing-desc">Portals, web apps, and complex builds tailored to your exact needs.</p>
            <ul className="pricing-features">
              <li>Full scoping session</li>
              <li>Custom functionality</li>
              <li>API integrations</li>
              <li>Ongoing support options</li>
              <li>Dedicated project manager</li>
            </ul>
            <button className="btn-outline-dark" onClick={() => navigate('/contact')}>Let's Talk</button>
          </div>
        </div>
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '25px' }}>
  <button
    className="btn-primary"
    onClick={() => navigate('/pricing')}
  >
    Use our pricing calculator!
  </button>
  <p>All prices are estimations*</p>
</div>
      </section>

      {/* ── FREE WEBSITE PROGRAM ── */}
      <section className="free-website">
        <div className="section-eyebrow">Community Program</div>
        <div className="section-title">Apply for a Free Website</div>
        <p className="section-sub" style={{ margin: '0 auto 36px', textAlign: 'center' }}>
          We give back by building free websites for qualifying small businesses and nonprofits in
          Ontario. Apply below, if you're approved, you'll book your kickoff call directly.
        </p>
        <div className="free-website-steps">
          <div className="step-pill"><span className="step-num">1</span> Submit your application</div>
          <div className="step-pill"><span className="step-num">2</span> We review &amp; approve</div>
          <div className="step-pill"><span className="step-num">3</span> Book your kickoff call</div>
          <div className="step-pill"><span className="step-num">4</span> We build your site 🎉</div>
        </div>
        <button className="btn-primary" onClick={() => navigate('/apply')}>
          Apply for a Free Website
        </button>
      </section>

      {/* ── SEE WORK ── */}
      <div className="see-work">
        <p>
          120+ projects completed. See the work that's helped Ontario businesses grow online.
        </p>
        <button className="btn-primary" onClick={() => navigate('/projects')}>
          See Our Work →
        </button>
      </div>

    </div>
  );
};

export default Home;